import { getAppConfig } from '../..';
export const loginRequestB2B = () => {
    const configuration = getAppConfig();
    return {
        scopes: [configuration.REACT_APP_BFF_API_SCOPES],
        redirectUri: '/',
    };
};
